import { MessagesInterface } from '../../model';

export const Messages: MessagesInterface = {
  loadNodesError: (name: string) => ({
    title: 'Server request error',
    message: `Could not get contents of "${name}"`,
  }),
};
